import React from 'react';
import Icon from '../ui/Icon';
import './ChallengeCard.css';

// A generic "play" entry point — Quick Play / Skill Practice / Timed
// Challenge / Mistake Recovery on the Practice hub. Deliberately does NOT
// show an XP/reward number: the actual XP a session earns depends on how
// many questions get answered correctly, which isn't known before it
// starts, and inventing a number here would violate the no-fabrication rule.
// `stat` is for real, already-known numbers only (e.g. mistake bank counts).
const ChallengeCard = ({ icon, art = false, title, subtitle, stat, difficulty, effort, onStart, tone = 'default', official = false }) => (
  <button type="button" className={`z-challenge-card z-challenge-card--${tone} ${official ? 'z-challenge-card--official' : ''}`} onClick={onStart}>
    <div className="z-challenge-icon" aria-hidden="true">{typeof icon === 'string' ? <Icon name={icon} art={art} size={art ? 34 : 24} /> : icon}</div>
    <div className="z-challenge-body">
      <span className="z-challenge-title">{title}</span>
      {subtitle && <span className="z-challenge-subtitle">{subtitle}</span>}
      <div className="z-challenge-meta">
        {stat && <span className="z-challenge-stat">{stat}</span>}
        {difficulty && <span className={`z-challenge-diff z-challenge-diff--${difficulty}`}>{difficulty}</span>}
        {effort && <span className="z-challenge-effort">{effort}</span>}
      </div>
    </div>
    <span className="z-challenge-arrow" aria-hidden="true"><Icon name="chevron-right" size={20} /></span>
  </button>
);

export default ChallengeCard;
